import emdrPsychotherapyQuestionSet from "../faq/emdrPsychotherapy/allQuestions";

export const psychoterapyEmdr = {
    'meta': {
        'title': 'Terapia EMDR #cityLocativeIn# • Centrum COLLIGO',
        'description': 'Terapia EMDR #cityLocativeIn#, prowadzona przez wyspecjalizowanych terapeutów.'
    },
    'availability': [
        'torun',
        'bydgoszcz'
    ],
    'price': {
        'torun': {
            'first': 170,
            'next': 170
        },
        'bydgoszcz': {
            'first': 160,
            'next': 160
        }
    },
    'url': {
        'address': '#cityIdUrl#/uslugi/terapia-emdr/',
        'title': 'Terapia EMDR #cityLocativeIn#',
        'name': 'Terapia EMDR #cityLocativeIn#',
        'heading': 'Terapia EMDR',
        'fullName': 'Terapia EMDR'
    },
    'image': {
        'url': '/images/services/terapia-emdr-w-toruniu.webp',
        'width': 886,
        'height': 295,
        'alt': 'Terapia EMDR'
    },
    'opengraph': {
        'image': {
            'url': '/images/services/open-graph/terapia-emdr-w-toruniu.jpg',
            'width': 886,
            'height': 295,
            'alt': 'Terapia EMDR'
        }
    },
    'faq': emdrPsychotherapyQuestionSet
}